import BaseApi from '@/api/Base/BaseApi'

import {
  ModelPipelineResultNodeInfo,
  ModelPipelineResultNodeItemListResponse,
  UpdateModelPipelineResultNodePayload
} from '@/api/ModelPipelineResultNode/types'
import { CommonListPayload } from '@/api/Node/types'
import { omitNilOrEmptyStringFromObject } from '@/utils/common'

// FIXME: root
const ROOT = '/model-pipeline-result'

const defaultPaginationOptions = {
  itemsPerPage: 40,
  page: 0,
  sortDir: 'desc',
  sortKey: 'createdAt',
}

export default class ModelPipelineResultNodeApi extends BaseApi {
  // NOTE: 추후 노드 타입까지 봐야할 경우를 대비해서 params 객체로 받도록함
  getModelPipelineResultNode(modelPipelineResultNodeId: string, params: { instanceNodeId?: string }) {
    const newParams = omitNilOrEmptyStringFromObject(params)
    return this.agent.get<ModelPipelineResultNodeInfo>(`${ROOT}/${modelPipelineResultNodeId}`, {
      params: newParams,
    })
  }

  getModelPipelineResultItems(modelPipelineResultNodeId: string, options?: CommonListPayload & { instanceNodeId?: string }) {
    const { itemsPerPage, page, sortDir, sortKey } = options ?? defaultPaginationOptions
    const newParams = omitNilOrEmptyStringFromObject({
      page,
      num_per_page: itemsPerPage,
      sort_key: sortKey,
      sort_dir: sortDir,
      instanceNodeId: options?.instanceNodeId,
    })
    return this.agent.get<ModelPipelineResultNodeItemListResponse>(`${ROOT}/${modelPipelineResultNodeId}/items`, {
      params: newParams,
    })
  }

  updateModelPipelineResultNode(payload: UpdateModelPipelineResultNodePayload) {
    const { modelPipelineResultNodeId, ...rest } = payload
    return this.agent.put(`${ROOT}/${modelPipelineResultNodeId}`, rest)
  }
}
